import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { Link } from 'shared/mui/Link/Link';
import { Typography } from 'shared/mui/Typography';

import { BoxWrapperStyled, ContentStyled } from './FileInputUpload.styled';

type FileInputUploadProps = {
  onClick?: () => void;
};

export const FileInputUpload = ({ onClick }: FileInputUploadProps) => {
  return (
    <BoxWrapperStyled onClick={onClick}>
      <ContentStyled>
        <UploadFileOutlinedIcon color="secondary" />
        <Typography variant="body2">
          <Link>Нажмите, чтобы загрузить</Link> или перетащите файл в формате .xlsx.
        </Typography>
      </ContentStyled>
    </BoxWrapperStyled>
  );
};
